/**
 * Detect whether Hovercontext is running on a mobile device.
 *
 * Combines a UA sniff with a viewport-width heuristic. Hovercontext is
 * desktop-first; on mobile we render a friendly message instead of the
 * launcher so users know to switch devices rather than fighting a
 * compromised touch UX.
 */
const MOBILE_UA = /Android|iPhone|iPad|iPod|Mobile|webOS|BlackBerry|Opera Mini/i;
const MOBILE_MAX_WIDTH = 720;
export const isMobile = () => {
    if (typeof window === "undefined")
        return false;
    const ua = navigator.userAgent ?? "";
    if (MOBILE_UA.test(ua))
        return true;
    // Touch + narrow screen — catches Surface tablets in portrait, iPad Mini, etc.
    const touch = typeof navigator !== "undefined" &&
        (navigator.maxTouchPoints ?? 0) > 1;
    if (touch && window.innerWidth <= MOBILE_MAX_WIDTH)
        return true;
    return false;
};
//# sourceMappingURL=isMobile.js.map